import request from '@/utils/httpRequest'

export default class DingtalkService {
    dingtalkLogin(code, corpId) {
        return request({
            url: '/sys/dingtalkLogin',
            method: 'post',
            params: {code: code, corpId: corpId}
        })
    }

    //物料管理系统后台钉钉免密登录接口
    materDingtalkLogin(code) {
        return request({
            url: '/mater/dingtalkLogin',
            method: 'post',
            params: {code: code},
            class: 'mater'
        })
    }

    chengBenDingtalkLogin(code) {
        return request({
            url: '/sales/codeLogin',
            method: 'post',
            params: {code: code},
            class: 'mater'
        })
    }

    getLoginCode(systemType) {
        return request({
            url: '/sys/getLoginCode',
            method: 'get',
            params: {
                systemType: systemType
            }
        })
    }

    //登录码登录
    codeLogin(mobile, loginCode) {
        return request({
            url: '/mater/codeLogin',
            // headers: {
            //     isToken: false
            // },
            class: 'mater',
            method: 'post',
            params: {
                mobile: mobile,
                loginCode: loginCode,
            }
        })
    }
}
